/* pz3-musica.js (da VIVA/musica.js, P2-VIVA) · Pozzalume · la colonna sonora del Teatrino di carta (24/10/2026)
   Diego: "una piccola colonna sonora che, in base a dove uno scorre, cambia suono: se un personaggio e' gentile
   fa una cosa dolce e divertente, se c'e' la nuvola dei suoni spaventosi una cosa super brandizzata".
   Un tema solo, il tema di Pozzalume: comincia con sol, do, mi come la firma sonora, valzer lento a 84 battiti in do.
   Diego, dopo il primo ascolto: "super dolce e leggera". Quindi carillon piu' morbido con un'eco di stanza, bassi
   bassi e lontani, dettagli rari, e un filtro che toglie gli spigoli prima dell'uscita.
   Ogni zona della pagina (attributo data-zona) lo veste in un altro modo: carillon, pizzicati, celesta,
   ocarina, sonagli. Il Musone lo porta in la minore, con la tuba che brontola, un tuono buffo e le scariche.
   Si cambia sul battito e il tono solo a inizio battuta: la musica non salta mai a meta' di una nota.
   Tutto da codice (Web Audio), nessun file. Vive dentro suoni.js come ambiente 'colonna': nasce solo quando
   chi guarda accende i suoni e si zittisce con l'interruttore o quando la pagina si nasconde.
   Espone window.PzMusica (ricette per suoni.js, zone, brani) e, mentre suona, window.__pzMusica per il collaudo. */
(function (w) {
  'use strict';
  var d = w.document;
  var B = 60 / 84;          // un battito
  var AVANTI = 0.3;         // quanto prima si programma un battito (sopra 0,1 s: non e' un "suono improvviso")

  function hz(m) { return 440 * Math.pow(2, (m - 69) / 12); }
  function rumore(ctx) { return w.Suoni.rumore(ctx); }
  function env(param, t, picco, a, giu) {
    param.setValueAtTime(0.0001, t);
    param.exponentialRampToValueAtTime(Math.max(picco, 0.0002), t + a);
    param.exponentialRampToValueAtTime(0.0001, t + a + giu);
  }
  function suonaOsc(ctx, out, t, tipo, f, picco, a, giu) {
    var o = ctx.createOscillator(), g = ctx.createGain();
    o.type = tipo; o.frequency.value = f;
    env(g.gain, t, picco, a, giu);
    o.connect(g); g.connect(out); o.start(t); o.stop(t + a + giu + 0.05);
    return o;
  }

  /* ---------- gli strumenti dell'orchestra di carta ---------- */
  var I = {
    // il carillon di Pozzalume: tre linguette, la prima lunga
    carillon: function (ctx, out, t, m, v) {
      var f = hz(m);
      suonaOsc(ctx, out, t, 'sine', f, 0.21 * v, 0.006, 1.7);
      suonaOsc(ctx, out, t, 'sine', f * 2, 0.032 * v, 0.004, 0.55);
      if (f * 3.01 < 12000) suonaOsc(ctx, out, t, 'sine', f * 3.01, 0.018 * v, 0.003, 0.28);
    },
    // celesta: campanelle morbide
    celesta: function (ctx, out, t, m, v, corto) {
      var f = hz(m), giu = corto ? 0.45 : 1.0;
      suonaOsc(ctx, out, t, 'sine', f, 0.2 * v, 0.003, giu);
      if (f * 4 < 12000) suonaOsc(ctx, out, t, 'sine', f * 4, 0.025 * v, 0.002, giu * 0.3);
    },
    // pizzicato d'archi: corda tirata con le dita
    pizz: function (ctx, out, t, m, v, corto) {
      var f = hz(m), o = ctx.createOscillator(), lp = ctx.createBiquadFilter(), g = ctx.createGain(), giu = corto ? 0.17 : 0.36;
      o.type = 'sawtooth'; o.frequency.value = f;
      lp.type = 'lowpass'; lp.Q.value = 1.1;
      lp.frequency.setValueAtTime(Math.min(2600, f * 6), t);
      lp.frequency.exponentialRampToValueAtTime(Math.max(260, f * 1.6), t + 0.16);
      env(g.gain, t, 0.085 * v, 0.004, giu);
      o.connect(lp); lp.connect(g); g.connect(out); o.start(t); o.stop(t + giu + 0.06);
    },
    // ocarina: la melodia di chi cammina
    ocarina: function (ctx, out, t, m, dur, v) {
      var f = hz(m), o = ctx.createOscillator(), lp = ctx.createBiquadFilter(), g = ctx.createGain();
      var vib = ctx.createOscillator(), vg = ctx.createGain();
      o.type = 'triangle'; o.frequency.value = f;
      lp.type = 'lowpass'; lp.frequency.value = f * 2.6; lp.Q.value = 0.5;
      vib.frequency.value = 5.2; vg.gain.setValueAtTime(0, t); vg.gain.linearRampToValueAtTime(f * 0.007, t + 0.3);
      vib.connect(vg); vg.connect(o.frequency);
      var fine = t + Math.max(0.1, dur - 0.06);
      g.gain.setValueAtTime(0.0001, t);
      g.gain.exponentialRampToValueAtTime(0.13 * v, t + 0.05);
      g.gain.setValueAtTime(0.13 * v, fine);
      g.gain.exponentialRampToValueAtTime(0.0001, fine + 0.14);
      o.connect(lp); lp.connect(g); g.connect(out);
      o.start(t); vib.start(t); o.stop(fine + 0.2); vib.stop(fine + 0.2);
      var n = ctx.createBufferSource(), bp = ctx.createBiquadFilter(), ng = ctx.createGain();
      n.buffer = rumore(ctx); bp.type = 'bandpass'; bp.frequency.value = f * 2; bp.Q.value = 2.5;
      env(ng.gain, t, 0.03 * v, 0.015, 0.09);
      n.connect(bp); bp.connect(ng); ng.connect(out); n.start(t, Math.random()); n.stop(t + 0.14);
    },
    // un tappeto caldo d'accordo, piano sotto a tutto
    tappeto: function (ctx, out, t, accordo, dur, v, scuro) {
      var lp = ctx.createBiquadFilter(), g = ctx.createGain(), fine = t + Math.max(0.3, dur);
      lp.type = 'lowpass'; lp.frequency.value = scuro ? 700 : 1150; lp.Q.value = 0.4;
      g.gain.setValueAtTime(0.0001, t);
      g.gain.exponentialRampToValueAtTime(0.03 * v, t + 0.4);
      g.gain.setValueAtTime(0.03 * v, fine);
      g.gain.exponentialRampToValueAtTime(0.0001, fine + 0.55);
      lp.connect(g); g.connect(out);
      accordo.forEach(function (m, i) {
        var o = ctx.createOscillator();
        o.type = 'triangle'; o.frequency.value = hz(m); o.detune.value = i % 2 ? 7 : -7;
        o.connect(lp); o.start(t); o.stop(fine + 0.6);
      });
    },
    // la tuba del Musone: brontola, non spaventa
    tuba: function (ctx, out, t, m, dur, v) {
      var f = hz(m), o = ctx.createOscillator(), lp = ctx.createBiquadFilter(), g = ctx.createGain();
      o.type = 'sawtooth';
      o.frequency.setValueAtTime(f * 0.96, t); o.frequency.exponentialRampToValueAtTime(f, t + 0.07);
      lp.type = 'lowpass'; lp.Q.value = 2.5;
      lp.frequency.setValueAtTime(f * 2, t); lp.frequency.exponentialRampToValueAtTime(f * 5.5, t + 0.06);
      lp.frequency.exponentialRampToValueAtTime(f * 2.4, t + dur);
      g.gain.setValueAtTime(0.0001, t);
      g.gain.exponentialRampToValueAtTime(0.16 * v, t + 0.05);
      g.gain.exponentialRampToValueAtTime(0.07 * v, t + dur * 0.6);
      g.gain.exponentialRampToValueAtTime(0.0001, t + dur + 0.12);
      o.connect(lp); lp.connect(g); g.connect(out); o.start(t); o.stop(t + dur + 0.2);
    },
    // il legnetto: tic di forbici sul tavolo
    legnetto: function (ctx, out, t, v, alto) {
      var f = alto ? 1320 : 940, o = ctx.createOscillator(), g = ctx.createGain();
      o.type = 'sine'; o.frequency.setValueAtTime(f, t); o.frequency.exponentialRampToValueAtTime(f * 0.68, t + 0.045);
      env(g.gain, t, 0.13 * v, 0.001, 0.055);
      o.connect(g); g.connect(out); o.start(t); o.stop(t + 0.09);
    },
    // sonagli d'inverno
    sonagli: function (ctx, out, t, v) {
      [5300, 6650].forEach(function (f, i) {
        suonaOsc(ctx, out, t + i * 0.011 + Math.random() * 0.006, 'sine', f * (1 + (Math.random() - 0.5) * 0.02), 0.026 * v, 0.002, 0.11);
      });
      var n = ctx.createBufferSource(), bp = ctx.createBiquadFilter(), g = ctx.createGain();
      n.buffer = rumore(ctx); bp.type = 'bandpass'; bp.frequency.value = 7600; bp.Q.value = 2;
      env(g.gain, t, 0.05 * v, 0.002, 0.07);
      n.connect(bp); bp.connect(g); g.connect(out); n.start(t, Math.random()); n.stop(t + 0.1);
    },
    // il tuono buffo del Musone: un brontolio che rotola, senza boati
    tuono: function (ctx, out, t, v) {
      var n = ctx.createBufferSource(), bp = ctx.createBiquadFilter(), lp = ctx.createBiquadFilter(), g = ctx.createGain();
      n.buffer = rumore(ctx); bp.type = 'bandpass'; bp.frequency.value = 230; bp.Q.value = 0.9;
      lp.type = 'lowpass'; lp.frequency.value = 520;
      g.gain.setValueAtTime(0.0001, t);
      [[0.18, 0.5], [0.42, 0.85], [0.7, 0.55], [1.05, 0.4]].forEach(function (q) {
        g.gain.exponentialRampToValueAtTime(q[1] * 0.5 * v, t + q[0]);
        g.gain.exponentialRampToValueAtTime(q[1] * 0.22 * v, t + q[0] + 0.12);
      });
      g.gain.exponentialRampToValueAtTime(0.0001, t + 1.8);
      n.connect(bp); bp.connect(lp); lp.connect(g); g.connect(out); n.start(t, 0.05); n.stop(t + 1.85);
    },
    // la scarica del Musone: un crepitio piccolo e un filo che scende
    scarica: function (ctx, out, t, v) {
      var n = ctx.createBufferSource(), hp = ctx.createBiquadFilter(), g = ctx.createGain(), tt = t;
      n.buffer = rumore(ctx); hp.type = 'highpass'; hp.frequency.value = 2300;
      g.gain.setValueAtTime(0.0001, t);
      while (tt < t + 0.2) {
        g.gain.setValueAtTime(0.0001, tt);
        g.gain.exponentialRampToValueAtTime((0.08 + Math.random() * 0.12) * v, tt + 0.002);
        g.gain.exponentialRampToValueAtTime(0.0001, tt + 0.011 + Math.random() * 0.01);
        tt += 0.016 + Math.random() * 0.022;
      }
      n.connect(hp); hp.connect(g); g.connect(out); n.start(t, Math.random()); n.stop(t + 0.26);
      var o = ctx.createOscillator(), lp = ctx.createBiquadFilter(), og = ctx.createGain();
      o.type = 'square'; o.frequency.setValueAtTime(1500, t); o.frequency.exponentialRampToValueAtTime(330, t + 0.17);
      lp.type = 'lowpass'; lp.frequency.value = 2400;
      env(og.gain, t, 0.03 * v, 0.004, 0.15);
      o.connect(lp); lp.connect(og); og.connect(out); o.start(t); o.stop(t + 0.22);
    },
    // il fischietto a coulisse: il Mulinello che gira
    fischietto: function (ctx, out, t, v, giu) {
      var o = ctx.createOscillator(), g = ctx.createGain(), vib = ctx.createOscillator(), vg = ctx.createGain();
      var a = giu ? 1450 : 620, b = giu ? 620 : 1450;
      o.type = 'sine'; o.frequency.setValueAtTime(a, t); o.frequency.exponentialRampToValueAtTime(b, t + 0.4);
      vib.frequency.value = 8.5; vg.gain.value = 16; vib.connect(vg); vg.connect(o.frequency);
      g.gain.setValueAtTime(0.0001, t);
      g.gain.exponentialRampToValueAtTime(0.075 * v, t + 0.04);
      g.gain.setValueAtTime(0.075 * v, t + 0.34);
      g.gain.exponentialRampToValueAtTime(0.0001, t + 0.5);
      o.connect(g); g.connect(out); o.start(t); vib.start(t); o.stop(t + 0.55); vib.stop(t + 0.55);
    },
    // la molla: un salto buffo
    molla: function (ctx, out, t, v) {
      var o = ctx.createOscillator(), g = ctx.createGain(), vib = ctx.createOscillator(), vg = ctx.createGain();
      o.type = 'triangle'; o.frequency.setValueAtTime(430, t); o.frequency.exponentialRampToValueAtTime(250, t + 0.34);
      vib.frequency.value = 15; vg.gain.setValueAtTime(55, t); vg.gain.exponentialRampToValueAtTime(2, t + 0.4);
      vib.connect(vg); vg.connect(o.frequency);
      env(g.gain, t, 0.12 * v, 0.006, 0.4);
      o.connect(g); g.connect(out); o.start(t); vib.start(t); o.stop(t + 0.46); vib.stop(t + 0.46);
    },
    // l'arpa di carta: una scala che sale
    arpa: function (ctx, out, t, v, note) {
      (note || [72, 76, 79, 84, 88, 91, 96]).forEach(function (m, i) {
        suonaOsc(ctx, out, t + i * 0.05, 'triangle', hz(m), 0.075 * v * (1 - i * 0.06), 0.003, 0.6);
      });
    }
  };

  /* ---------- il tema di Pozzalume, 16 battute: A in do maggiore, B che sale e torna ---------- */
  // accordi: [battito, basso, triade]; melodia: [battito, nota, durata in battiti]
  var DO = [64, 67, 72], LAm = [64, 69, 72], FA = [65, 69, 72], SOL = [62, 67, 71], REm = [62, 65, 69], MI = [64, 68, 71];
  var TEMI = {
    maggiore: {
      accordi: [
        [[0, 48, DO]], [[0, 45, LAm]], [[0, 53, FA]], [[0, 55, SOL]], [[0, 48, DO]], [[0, 45, LAm]], [[0, 53, FA], [2, 55, SOL]], [[0, 48, DO]],
        [[0, 53, FA]], [[0, 48, DO]], [[0, 55, SOL]], [[0, 45, LAm]], [[0, 53, FA]], [[0, 48, DO]], [[0, 55, SOL]], [[0, 48, DO]]
      ],
      melodia: [
        [[0, 79, 1], [1, 84, 1], [2, 88, 1]], [[0, 86, 1.5], [1.5, 84, 0.5], [2, 81, 1]], [[0, 84, 1], [1, 81, 1], [2, 77, 1]], [[0, 79, 1.5], [1.5, 81, 0.5], [2, 83, 1]],
        [[0, 79, 1], [1, 84, 1], [2, 88, 1]], [[0, 88, 1], [1, 86, 1], [2, 84, 1]], [[0, 81, 1], [1, 84, 1], [2, 83, 1]], [[0, 84, 3]],
        [[0, 81, 1], [1, 77, 1], [2, 81, 1]], [[0, 79, 1.5], [1.5, 76, 0.5], [2, 79, 1]], [[0, 83, 1], [1, 86, 1], [2, 83, 1]], [[0, 84, 2], [2, 81, 1]],
        [[0, 81, 1], [1, 84, 1], [2, 89, 1]], [[0, 88, 1.5], [1.5, 86, 0.5], [2, 84, 1]], [[0, 86, 1], [1, 83, 1], [2, 79, 1]], [[0, 84, 3]]
      ]
    },
    minore: {
      accordi: [
        [[0, 45, LAm]], [[0, 45, LAm]], [[0, 50, REm]], [[0, 52, MI]], [[0, 45, LAm]], [[0, 53, FA]], [[0, 52, MI]], [[0, 45, LAm]],
        [[0, 50, REm]], [[0, 45, LAm]], [[0, 52, MI]], [[0, 45, LAm]], [[0, 50, REm]], [[0, 45, LAm]], [[0, 52, MI]], [[0, 45, LAm]]
      ],
      melodia: [
        [[0, 76, 1], [1, 81, 1], [2, 84, 1]], [[0, 83, 1.5], [1.5, 81, 0.5], [2, 76, 1]], [[0, 81, 1], [1, 77, 1], [2, 74, 1]], [[0, 76, 1.5], [1.5, 77, 0.5], [2, 80, 1]],
        [[0, 76, 1], [1, 81, 1], [2, 84, 1]], [[0, 84, 1], [1, 83, 1], [2, 81, 1]], [[0, 80, 1], [1, 83, 1], [2, 86, 1]], [[0, 81, 3]],
        [[0, 77, 1], [1, 74, 1], [2, 77, 1]], [[0, 76, 1.5], [1.5, 72, 0.5], [2, 76, 1]], [[0, 80, 1], [1, 83, 1], [2, 80, 1]], [[0, 81, 2], [2, 76, 1]],
        [[0, 77, 1], [1, 81, 1], [2, 86, 1]], [[0, 84, 1.5], [1.5, 83, 0.5], [2, 81, 1]], [[0, 83, 1], [1, 80, 1], [2, 76, 1]], [[0, 81, 3]]
      ]
    }
  };

  /* ---------- le zone: come ogni parte della pagina veste il tema ---------- */
  // mel: [strumento, forza, staccato, ottava]; basso: uno | ompapa | punte | cammino | tuba; vol: livello della zona
  var ZONE = {
    palco:    { brano: 'ninna', tema: 'maggiore', mel: ['carillon', 1], basso: 'uno', tappeto: 0.9, vol: 1 },
    creature: { brano: 'creature', tema: 'minore', mel: ['celesta', 1, true], basso: 'punte', luccichii: true, vol: 0.95 },
    kit:      { brano: 'forbici', tema: 'maggiore', mel: ['carillon', 1], basso: 'ompapa', legnetti: true, vol: 1 },
    fogli:    { brano: 'tavolo', tema: 'maggiore', mel: ['carillon', 0.9], basso: 'uno', tappeto: 0.6, vol: 0.9 },
    passi:    { brano: 'tavolo', tema: 'maggiore', mel: ['carillon', 0.9], basso: 'uno', tappeto: 0.6, vol: 0.9 },
    gentile:  { brano: 'gentile', tema: 'maggiore', mel: ['celesta', 1], ottava: ['carillon', 0.4, 12], basso: 'ompapa', molla: true, vol: 1 },
    quando:   { brano: 'passeggiata', tema: 'maggiore', mel: ['ocarina', 1], basso: 'cammino', vol: 1 },
    assaggio: { brano: 'tavolo', tema: 'maggiore', mel: ['carillon', 0.85], basso: 'uno', tappeto: 0.5, vol: 0.85 },
    // P4-SISTEMA (N11 di P3): la sezione dei doni aveva data-zona="doni" ma nessuna zona, e la musica restava su assaggio
    doni:     { brano: 'gentile', tema: 'maggiore', mel: ['celesta', 0.9], basso: 'uno', tappeto: 0.6, vol: 0.9 },
    mondo:    { brano: 'musone', tema: 'minore', mel: ['celesta', 0.95, true], basso: 'tuba', tappeto: 0.7, scuro: true, tuono: true, vol: 1 },
    inverno:  { brano: 'mulinello', tema: 'maggiore', mel: ['celesta', 0.9, false, 12], basso: 'ompapa', sonagli: true, fischietto: true, vol: 0.95 },
    fonti:    { brano: 'lanterna', tema: 'maggiore', mel: ['carillon', 0.6], tappeto: 0.7, vol: 0.75 },
    origine:  { brano: 'lanterna', tema: 'maggiore', mel: ['carillon', 0.6], tappeto: 0.7, vol: 0.75 },
    aggiornamenti: { brano: 'lanterna', tema: 'maggiore', mel: ['carillon', 0.6], tappeto: 0.7, vol: 0.75 },
    domande:  { brano: 'lanterna', tema: 'maggiore', mel: ['carillon', 0.6], tappeto: 0.7, vol: 0.75 },
    offerta:  { brano: 'finale', tema: 'maggiore', mel: ['carillon', 1], ottava: ['celesta', 0.35, 12], basso: 'ompapa', tappeto: 0.6, vol: 1 },
    piede:    { brano: 'buonanotte', tema: 'maggiore', mel: ['carillon', 0.55], tappeto: 0.45, rado: true, vol: 0.7 },
    // il mondo dopo che chi guarda ha riacceso le sette lanterne (vivi.js): il Musone se n'e' andato
    festa:    { brano: 'festa', tema: 'maggiore', mel: ['carillon', 1], ottava: ['celesta', 0.3, 12], basso: 'ompapa', tappeto: 0.6, vol: 1 }
  };
  var ENTRATE = {  // il piccolo gesto quando si entra in una zona
    mondo: function (ctx, out, t) { I.tuono(ctx, out, t, 0.6); },
    festa: function (ctx, out, t) { I.arpa(ctx, out, t, 0.8); },
    inverno: function (ctx, out, t) { [0, 0.09, 0.18].forEach(function (k) { I.sonagli(ctx, out, t + k, 1); }); I.fischietto(ctx, out, t + 0.12, 0.8); },
    offerta: function (ctx, out, t) { I.arpa(ctx, out, t, 1); },
    gentile: function (ctx, out, t) { I.molla(ctx, out, t, 0.8); },
    kit: function (ctx, out, t) { I.legnetto(ctx, out, t, 1, true); I.legnetto(ctx, out, t + 0.12, 1); },
    creature: function (ctx, out, t) { [83, 85, 87].forEach(function (m, i) { I.celesta(ctx, out, t + i * 0.08, m, 0.7, true); }); }
  };

  function accordoA(tema, battuta, b) {
    var lista = TEMI[tema].accordi[battuta], c = lista[0];
    for (var i = 0; i < lista.length; i++) if (lista[i][0] <= b) c = lista[i];
    return c;
  }

  // programma un battito (b = 0, 1, 2 della battuta) della zona z, dal tempo t
  function battito(ctx, out, t, z, tema, battuta, b) {
    var Z = ZONE[z] || ZONE.palco, T = TEMI[tema], acc = accordoA(tema, battuta, b);
    var cambioAccordo = T.accordi[battuta].some(function (x) { return x[0] === b; });
    // melodia
    T.melodia[battuta].forEach(function (n) {
      if (n[0] < b || n[0] >= b + 1) return;
      if (Z.rado && n[0] !== 0) return;
      var tn = t + (n[0] - b) * B, m = n[1] + (Z.mel[3] || 0), f = Z.mel[1];
      if (Z.mel[0] === 'ocarina') I.ocarina(ctx, out, tn, m, n[2] * B, f);
      else if (Z.mel[0] === 'celesta') I.celesta(ctx, out, tn, m, f, Z.mel[2]);
      else I.carillon(ctx, out, tn, m, f);
      if (Z.ottava) {
        if (Z.ottava[0] === 'celesta') I.celesta(ctx, out, tn, m + Z.ottava[2], Z.ottava[1], true);
        else I.carillon(ctx, out, tn, m + Z.ottava[2], Z.ottava[1]);
      }
    });
    // basso e accordi
    var radice = acc[1], triade = acc[2];
    if (Z.basso === 'uno' && b === 0) I.pizz(ctx, out, t, radice, 0.8);
    if (Z.basso === 'ompapa') {
      if (b === 0) I.pizz(ctx, out, t, radice, 0.9);
      else { I.pizz(ctx, out, t, triade[0], 0.3, true); I.pizz(ctx, out, t, triade[1], 0.26, true); }
    }
    if (Z.basso === 'punte') {  // in punta di piedi: corto e leggero
      if (b === 0) I.pizz(ctx, out, t, radice, 0.75, true);
      else I.pizz(ctx, out, t, triade[b === 1 ? 0 : 1], 0.4, true);
    }
    if (Z.basso === 'cammino') I.pizz(ctx, out, t, radice + [0, 7, 12][b], b === 0 ? 0.85 : 0.6, true);
    if (Z.basso === 'tuba') {
      if (b === 0) I.tuba(ctx, out, t, radice, B * 1.1, 0.72);
      else I.pizz(ctx, out, t, triade[b === 1 ? 0 : 1] - 12, 0.38, true);
    }
    if (Z.tappeto && cambioAccordo) {
      var resta = 3 - b, lista = T.accordi[battuta];
      for (var i = 0; i < lista.length; i++) if (lista[i][0] > b) { resta = lista[i][0] - b; break; }
      I.tappeto(ctx, out, t, Z.scuro ? triade.map(function (m) { return m - 12; }) : triade, resta * B, Z.tappeto, Z.scuro);
    }
    // i dettagli di ogni zona
    if (Z.legnetti && b > 0 && battuta % 4 === 0) I.legnetto(ctx, out, t, 0.5, b === 2);
    if (Z.luccichii && battuta % 4 === 3 && b === 2) [81, 83, 85].forEach(function (m, i) { I.celesta(ctx, out, t + i * 0.1, m + 7, 0.55, true); });
    if (Z.molla && battuta % 8 === 3 && b === 2) I.molla(ctx, out, t + B * 0.5, 0.7);
    if (Z.tuono && battuta % 8 === 2 && b === 1) I.tuono(ctx, out, t, 0.45);
    if (Z.sonagli && b !== 1) I.sonagli(ctx, out, t, b === 0 ? 0.55 : 0.32);
    if (Z.fischietto && battuta % 8 === 7 && b === 1) I.fischietto(ctx, out, t, 0.7);
  }

  /* ---------- l'ambiente 'colonna' per suoni.js ---------- */
  function colonna(ctx, out, p) {
    p = p || {};
    var offline = typeof OfflineAudioContext !== 'undefined' && ctx instanceof OfflineAudioContext;
    var t0 = ctx.currentTime + (offline ? 0.05 : 1.75);  // dal vivo parte dopo la firma
    var bus = ctx.createGain();
    bus.gain.setValueAtTime(0.0001, ctx.currentTime);
    bus.gain.setValueAtTime(0.0001, t0 - 0.05);
    bus.gain.exponentialRampToValueAtTime(1, t0 + 0.6);
    bus.connect(out);
    // l'uscita morbida: un filtro che toglie gli spigoli e un'eco di stanza piccola, come un carillon sul tavolo
    var mix = ctx.createGain(), liscio = ctx.createBiquadFilter(), eco = ctx.createDelay(1), ritorno = ctx.createGain(), velo = ctx.createBiquadFilter(), coda = ctx.createGain();
    mix.gain.value = 1;
    liscio.type = 'lowpass'; liscio.frequency.value = 5200; liscio.Q.value = 0.3;
    eco.delayTime.value = 0.34; ritorno.gain.value = 0.26; velo.type = 'lowpass'; velo.frequency.value = 2100; coda.gain.value = 0.2;
    mix.connect(liscio); liscio.connect(bus);
    liscio.connect(eco); eco.connect(velo); velo.connect(ritorno); ritorno.connect(eco); velo.connect(coda); coda.connect(bus);
    var stato = w.__pzMusica = { zona: p.zona || 'palco', candidata: p.zona || 'palco', da: 0, cambi: [], battiti: 0, tema: 'maggiore' };
    var n = 0, temaBattuta = 'maggiore', timer = null, attivo = true, io = null, visibili = [];

    function zonaDa(el) { return el && el.getAttribute('data-zona'); }
    function profondita(el) { var k = 0; while (el) { k++; el = el.parentElement; } return k; }
    function scegli() {
      if (!visibili.length) return;
      var meglio = visibili.reduce(function (a, b) { return profondita(b) > profondita(a) ? b : a; });
      var z = zonaDa(meglio);
      if (z && ZONE[z] && z !== stato.candidata) { stato.candidata = z; stato.da = ctx.currentTime; }
    }
    if (!offline && 'IntersectionObserver' in w) {
      // una riga sottile a meta' dello schermo: la zona e' quella che ci passa sopra (la piu' interna vince)
      io = new IntersectionObserver(function (voci) {
        voci.forEach(function (x) {
          var i = visibili.indexOf(x.target);
          if (x.isIntersecting && i < 0) visibili.push(x.target);
          if (!x.isIntersecting && i >= 0) visibili.splice(i, 1);
        });
        scegli();
      }, { rootMargin: '-48% 0px -48% 0px', threshold: 0 });
      Array.prototype.forEach.call(d.querySelectorAll('[data-zona]'), function (el) { io.observe(el); });
    }

    function annuncia(z) {
      stato.cambi.push({ t: Math.round(ctx.currentTime * 100) / 100, zona: z });
      if (stato.cambi.length > 60) stato.cambi.shift();
      try { d.dispatchEvent(new CustomEvent('pz:brano', { detail: { zona: z, brano: ZONE[z].brano } })); } catch (e) {}
    }

    function programma(fino) {
      while (t0 + n * B < fino) {
        var t = t0 + n * B, b = n % 3, battuta = Math.floor(n / 3) % 16;
        // la zona cambia sul battito (dopo 0,25 s di calma), il tono solo a inizio battuta
        if (stato.candidata !== stato.zona && (offline || ctx.currentTime - stato.da > 0.25)) {
          stato.zona = stato.candidata;
          var Zn = ZONE[stato.zona];
          mix.gain.setTargetAtTime(Zn.vol, t, 0.25);
          if (ENTRATE[stato.zona] && n > 0) ENTRATE[stato.zona](ctx, mix, t);
          annuncia(stato.zona);
        }
        if (b === 0) temaBattuta = ZONE[stato.zona].tema;
        stato.tema = temaBattuta;
        battito(ctx, mix, t, stato.zona, temaBattuta, battuta, b);
        stato.battiti = ++n;
      }
    }

    if (offline) programma(ctx.currentTime + ((p && p.durata) || 8));
    else {
      annuncia(stato.zona);
      programma(ctx.currentTime + AVANTI);
      timer = setInterval(function () { if (attivo) programma(ctx.currentTime + AVANTI); }, 90);
    }

    // le scariche del Musone (vivi.js) suonano col tempo della musica
    function scarica(e) {
      if (!attivo || ctx.state !== 'running') return;
      var forte = e && e.detail && e.detail.tocco;
      I.scarica(ctx, mix, ctx.currentTime + 0.02, forte ? 1 : 0.7);
    }
    if (!offline) d.addEventListener('pz:scarica', scarica);

    return {
      imposta: function (chiave, val) { if (chiave === 'zona' && ZONE[val]) { stato.candidata = val; stato.da = -1; } },
      ferma: function () {
        attivo = false;
        if (timer) clearInterval(timer);
        if (io) io.disconnect();
        d.removeEventListener('pz:scarica', scarica);
        var t = ctx.currentTime;
        bus.gain.cancelScheduledValues(t);
        bus.gain.setValueAtTime(Math.max(bus.gain.value, 0.0001), t);
        bus.gain.exponentialRampToValueAtTime(0.0001, t + 0.5);
        setTimeout(function () { try { bus.disconnect(); } catch (e) {} }, 700);
      }
    };
  }

  /* ---------- le voci dei personaggi (ricette per suoni.js, suonano solo al tocco) ---------- */
  function k(p) { return Math.round(12 * Math.log(((p && p.tono) || 1)) / Math.LN2); }
  function quando(ctx, p) { return ctx.currentTime + ((p && p.ritardo) || 0); }
  function forza(p) { return p && p.volume != null ? p.volume : 1; }
  var R = {
    colonna: colonna,
    // la Torta Fuggitiva scappa sulle sue gambette: passetti di legno e una scala che corre
    torta: function (ctx, out, p) {
      var t = quando(ctx, p), v = forza(p), s = k(p);
      [0, 0.07, 0.14, 0.21, 0.28].forEach(function (q, i) { I.legnetto(ctx, out, t + q, 0.9 * v, i % 2 === 0); });
      [72, 74, 76, 77, 79, 81, 84].forEach(function (m, i) { I.pizz(ctx, out, t + 0.04 + i * 0.045, m + s, 0.9 * v, true); });
      return 0.75;
    },
    // un personaggio di carta fa un saltello: una molla e due note di carillon
    saltello: function (ctx, out, p) {
      var t = quando(ctx, p), v = forza(p), s = k(p);
      I.molla(ctx, out, t, 0.8 * v);
      I.carillon(ctx, out, t + 0.16, 79 + s, 0.75 * v);
      I.carillon(ctx, out, t + 0.3, 84 + s, 0.75 * v);
      return 1.5;
    },
    // il Musone brontola: due colpi di tuba che scendono e una scarica piccola
    musone: function (ctx, out, p) {
      var t = quando(ctx, p), v = forza(p);
      I.tuba(ctx, out, t, 52, 0.28, 0.95 * v);
      I.tuba(ctx, out, t + 0.3, 50, 0.42, 0.95 * v);
      I.scarica(ctx, out, t + 0.5, 0.9 * v);
      return 1.0;
    },
    // il Mulinello gira come una trottola: fischietto che sale, sonagli, una nota felice
    mulinello: function (ctx, out, p) {
      var t = quando(ctx, p), v = forza(p);
      I.fischietto(ctx, out, t, 0.95 * v);
      [0.05, 0.15, 0.25, 0.35].forEach(function (q) { I.sonagli(ctx, out, t + q, 0.9 * v); });
      I.celesta(ctx, out, t + 0.48, 88, 0.8 * v);
      return 1.3;
    },
    // una creatura della sera diventa amica: la celesta sale e il carillon chiude
    amica: function (ctx, out, p) {
      var t = quando(ctx, p), v = forza(p);
      [72, 76, 79, 84].forEach(function (m, i) { I.celesta(ctx, out, t + i * 0.09, m, 0.85 * v, true); });
      I.carillon(ctx, out, t + 0.4, 88, 0.85 * v);
      return 1.8;
    },
    // una lanterna si riaccende: la fiammella che prende e una nota del tema (vivi.js passa la nota giusta,
    // cosi' chi riaccende le sette lanterne, in qualunque ordine, suona l'inizio del tema di Pozzalume)
    lanterna: function (ctx, out, p) {
      var t = quando(ctx, p), v = forza(p), m = (p && p.nota) || 79;
      var n = ctx.createBufferSource(), bp = ctx.createBiquadFilter(), g = ctx.createGain();
      n.buffer = rumore(ctx); bp.type = 'bandpass'; bp.Q.value = 1.2;
      bp.frequency.setValueAtTime(800, t); bp.frequency.exponentialRampToValueAtTime(2400, t + 0.14);
      env(g.gain, t, 0.05 * v, 0.03, 0.15);
      n.connect(bp); bp.connect(g); g.connect(out); n.start(t, Math.random()); n.stop(t + 0.22);
      I.carillon(ctx, out, t + 0.06, m, 0.95 * v);
      I.celesta(ctx, out, t + 0.06, m + 12, 0.28 * v, true);
      return 1.8;
    },
    // tutte e sette accese: l'arpa sale, quattro accordi di carillon, una molla contenta
    festa: function (ctx, out, p) {
      var t = quando(ctx, p), v = forza(p);
      I.arpa(ctx, out, t, 0.85 * v);
      [[72, 76, 79], [77, 81, 84], [79, 83, 86], [84, 88, 91]].forEach(function (acc, i) {
        acc.forEach(function (m) { I.carillon(ctx, out, t + 0.45 + i * 0.34, m, 0.5 * v); });
      });
      I.molla(ctx, out, t + 1.9, 0.55 * v);
      return 3.4;
    },
    // Vecchio Silenzio russa: un respiro lungo, un ronfo di lana che vibra e il fischietto piccolo di chi dorme
    russa: function (ctx, out, p) {
      var t = quando(ctx, p), v = forza(p);
      var n = ctx.createBufferSource(), lp = ctx.createBiquadFilter(), g = ctx.createGain();
      n.buffer = rumore(ctx); lp.type = 'lowpass'; lp.frequency.value = 850;
      g.gain.setValueAtTime(0.0001, t); g.gain.exponentialRampToValueAtTime(0.07 * v, t + 0.7); g.gain.exponentialRampToValueAtTime(0.0001, t + 1.0);
      n.connect(lp); lp.connect(g); g.connect(out); n.start(t, Math.random()); n.stop(t + 1.05);
      var r = ctx.createBufferSource(), bp = ctx.createBiquadFilter(), rg = ctx.createGain(), tt = t + 1.05;
      r.buffer = rumore(ctx); bp.type = 'bandpass'; bp.frequency.value = 150; bp.Q.value = 3.5;
      rg.gain.setValueAtTime(0.0001, tt);
      while (tt < t + 1.9) {
        rg.gain.exponentialRampToValueAtTime(0.5 * v, tt + 0.02);
        rg.gain.exponentialRampToValueAtTime(0.16 * v, tt + 0.045);
        tt += 0.05;
      }
      rg.gain.exponentialRampToValueAtTime(0.0001, t + 2.05);
      r.connect(bp); bp.connect(rg); rg.connect(out); r.start(t + 1.05, Math.random()); r.stop(t + 2.1);
      var o = ctx.createOscillator(), og = ctx.createGain();
      o.type = 'sine'; o.frequency.setValueAtTime(1650, t + 2.1); o.frequency.exponentialRampToValueAtTime(2150, t + 2.45);
      env(og.gain, t + 2.1, 0.022 * v, 0.06, 0.3);
      o.connect(og); og.connect(out); o.start(t + 2.1); o.stop(t + 2.5);
      return 2.6;
    },
    // Nasobrontolo annusa tre volte, brontola contento e trova una cosa che luccica
    naso: function (ctx, out, p) {
      var t = quando(ctx, p), v = forza(p);
      [0, 0.13, 0.26].forEach(function (q, i) {
        var n = ctx.createBufferSource(), bp = ctx.createBiquadFilter(), g = ctx.createGain();
        n.buffer = rumore(ctx); bp.type = 'bandpass'; bp.Q.value = 2;
        bp.frequency.setValueAtTime(1800 + i * 300, t + q); bp.frequency.exponentialRampToValueAtTime(3200 + i * 300, t + q + 0.08);
        env(g.gain, t + q, 0.07 * v, 0.02, 0.07);
        n.connect(bp); bp.connect(g); g.connect(out); n.start(t + q, Math.random()); n.stop(t + q + 0.12);
      });
      I.tuba(ctx, out, t + 0.45, 55, 0.16, 0.55 * v);
      I.tuba(ctx, out, t + 0.63, 59, 0.24, 0.55 * v);
      I.celesta(ctx, out, t + 0.95, 91, 0.7 * v, true);
      I.celesta(ctx, out, t + 1.05, 96, 0.5 * v, true);
      return 1.6;
    },
    // Luna, la draghetta: uno sbuffo piccolo (un drago che ha paura del buio non fa fuoco) e la celesta che sale
    luna: function (ctx, out, p) {
      var t = quando(ctx, p), v = forza(p);
      var n = ctx.createBufferSource(), bp = ctx.createBiquadFilter(), g = ctx.createGain();
      n.buffer = rumore(ctx); bp.type = 'bandpass'; bp.Q.value = 1;
      bp.frequency.setValueAtTime(1400, t); bp.frequency.exponentialRampToValueAtTime(500, t + 0.26);
      env(g.gain, t, 0.08 * v, 0.03, 0.24);
      n.connect(bp); bp.connect(g); g.connect(out); n.start(t, Math.random()); n.stop(t + 0.32);
      [84, 88, 91, 96].forEach(function (m, i) { I.celesta(ctx, out, t + 0.22 + i * 0.08, m, 0.7 * v, true); });
      return 1.4;
    }
  };

  w.PzMusica = { ricette: R, strumenti: I, zone: ZONE, temi: TEMI, battito: B };
})(window);
